import { fromJS } from 'immutable';
import { actions } from './actions';
import statsd from '../../../lib/StatsD';
import * as lib from './lib';

function featureToggle(state, key) {
  const feature = state.get(key);
  const value = !feature.get('value');
  const preChange = lib.preChange(state, key, value);
  if (preChange === false) {
    // blocking
    return state;
  }
  lib.postChange(state, key, value);
  statsd.increment(`features.${key}.${value ? 'enabled' : 'disabled'}`);
  return state.setIn([key, 'value'], value);
}

const initialState = fromJS(lib.getAvailableFeatures());

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET_FEATURE:
      return state.set(value.key, value.value);
    case actions.TOGGLE_FEATURE:
      return featureToggle(state, value);
    case actions.UPDATE_FEATURES:
      return fromJS(value);
    case actions.CLEAR:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/features/reducer.js